import flatpickr from "flatpickr";
import flatpickrLanguages from "flatpickr/dist/l10n";
import BookingProcess from "./modules/frontv2/BookingProcess";
import Modal from "./modules/frontv2/Modal";
import * as Sentry from "@sentry/browser";
import { initDrops } from "./modules/common/drop";
import { initScroll } from "./modules/scrolling";
import { initMobileMenu } from "./modules/common/mobile-menu";
import { initSelects } from "./modules/common/selects";
import { initGoogleEcommerce } from "./modules/google_ecommerce";
import { getUserLanguage, ajax } from "./modules/utils";
import { initFormValidation } from "./modules/common/form-validation";
import Wish from "./modules/frontv2/Wish";
import tippy from "tippy.js";
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
import { initCommon } from "./modules/common/common";
import ReviewsFiltering from "./modules/frontv2/ReviewsFiltering";
import { initMaplibre } from "./modules/frontv2/Maplibre";
import { initMessages } from './modules/common/message';
import { initScrollInto } from './modules/common/scroll-into';
import { initSwiper } from "./modules/common/init-swiper";
import { initSeeMoreContent } from './modules/frontv2/seeMoreContent';
import { initCopyLinkToClipboard } from './modules/common/init-copy-link-to-clipboard';
import WinalistBusiness from './modules/frontv2/WinalistBusiness';
import { initBookingFormStickyEffect } from "./modules/frontv2/BookingFormStickyEffect";
import { initExperienceScrollNavbar } from "./modules/frontv2/ExperienceScrollNavbar";
import { initOpenBookingFormDate } from "./modules/frontv2/Booking/openBookingFormDate";
import { initAutocomplete } from "./modules/frontv2/Autocomplete";
import VisitorProposeSlots from "./modules/frontv2/VisitorProposeSlots";
import { initLightboxLinker } from "./modules/common/gallery-lightbox-linker";

document.addEventListener('DOMContentLoaded', () => {
  // Init Sentry JS
  if(document.body.dataset.env === 'prod') {
    Sentry.init({ dsn: 'https://b14c92e307604f4f8f454ebdd3eab1ef@sentry.io/1441102' });
  }

  flatpickr.localize(flatpickrLanguages[getUserLanguage()]);

  //common stuff
  initCommon();

  //Dropdowns and dropups
  initDrops();

  //Flash messages
  initMessages();

  initScrollInto();

  //Init modal logic
  Modal.bindAllModals();

  //Header bar scroll logic
  initScroll();

  const bookingForm = document.getElementById('booking-form');
  if(bookingForm && bookingForm.dataset.state === 'publish') {
    new BookingProcess();
  }

  //Mobile menu
  initMobileMenu();

  //Init selects for langs (down the page)
  initSelects();

  //Init see more logic (description of the exp)
  initSeeMoreContent();

  //Init wish add/remove buttons
  Wish.bindWishButtons();

  initFormValidation();

  //Analytics
  initGoogleEcommerce();

  //Tooltips
  tippy('[data-tippy-content]', {
    theme: 'light'
  });

  //Handle AJAX Reviews Pagination
  new ReviewsFiltering();

  //Init map logic
  initMaplibre();

  //logic for sliders
  initSwiper();

  //init the navbar that appears on scroll
  initExperienceScrollNavbar();

  // Copy link to share experience
  initCopyLinkToClipboard();

  //Init booking form sticky effect
  initBookingFormStickyEffect();

  //logic for the winalist business block (to send quotes)
  new WinalistBusiness();

  //logic for the visitor suggests slots block (to send suggestions)
  new VisitorProposeSlots();

  //bind buttons to open the booking form date
  initOpenBookingFormDate();

  //Search bar logic algolia
  initAutocomplete();

  //Lightbox linker
  initLightboxLinker();
});
